var map = {
	"./API.svg": "Rz8t",
	"./API_LIST.svg": "CsMu",
	"./api_order.svg": "17pO",
	"./authorization-list.svg": "P5Zq",
	"./client-list.svg": "XvY8",
	"./client.svg": "mKol",
	"./companyAnalysis.svg": "orBZ",
	"./constitution.svg": "lduv",
	"./customer-service.svg": "GUWR",
	"./data-center.svg": "hRKt",
	"./data.svg": "RUrO",
	"./device.svg": "k6Cd",
	"./dictionary.svg": "YRIb",
	"./example.svg": "OOLB",
	"./eye.svg": "4wdf",
	"./face-set.svg": "lGnn",
	"./faceset.svg": "9603",
	"./finance.svg": "pTuU",
	"./form.svg": "sTIr",
	"./hardware.svg": "xs9/",
	"./home.svg": "U9Ws",
	"./info.svg": "Yfis",
	"./layout.svg": "zfYT",
	"./log.svg": "8uFK",
	"./login-mall.svg": "xzZT",
	"./login-shop.svg": "1r5F",
	"./marker.svg": "0+/s",
	"./medicine-convert.svg": "joye",
	"./module.svg": "vP2Z",
	"./mood.svg": "/kpd",
	"./new-log.svg": "tx/X",
	"./order-return-reason.svg": "PeRC",
	"./order-return.svg": "vigK",
	"./order-setting.svg": "LpN3",
	"./order.svg": "gYtG",
	"./password.svg": "QjmH",
	"./picture.svg": "3n9f",
	"./product-add.svg": "Cuqr",
	"./product-attr.svg": "Aain",
	"./product-brand.svg": "JTBo",
	"./product-cate.svg": "G6Qz",
	"./product-comment.svg": "b5pz",
	"./product-list.svg": "qzoa",
	"./product-recycle.svg": "WSWy",
	"./product.svg": "UHi4",
	"./relation.svg": "b2wR",
	"./setting.svg": "Kttn",
	"./shop.svg": "hert",
	"./software-list.svg": "3r8E",
	"./software.svg": "utSR",
	"./statistic.svg": "afyG",
	"./statistics.svg": "2O5N",
	"./store-apply.svg": "d5b9",
	"./store-list.svg": "Lwy5",
	"./store.svg": "Lta+",
	"./supplier.svg": "oCxJ",
	"./table.svg": "oSYw",
	"./total-today.svg": "le/7",
	"./total-week.svg": "csmh",
	"./total-yesterday.svg": "C15R",
	"./tree.svg": "3eCm",
	"./ums-admin.svg": "FR/6",
	"./ums-menu.svg": "sr5k",
	"./ums-resource.svg": "noU8",
	"./ums-role.svg": "w7oB",
	"./ums.svg": "J4x9",
	"./user.svg": "VdD3",
	"./word.svg": "ELgs"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "90Fk";


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg nonrecursive \.svg$
// module id = 90Fk
// module chunks = 72